import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appRestrictionsInput]',
})
export class RestrictionsInputDirective {
  @Input() blockNumbers = false;
  @Input() blockNegative = false;
  @Input() resetNegative = false;

  constructor(private el: ElementRef<HTMLInputElement>, private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.blockNumbers && event.key >= '0' && event.key <= '9') {
      event.preventDefault();
    }

    if (this.blockNegative && event.key === '-') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text');
    if (!pastedText) {
      return;
    }

    const hasNumber = this.blockNumbers && /\d/.test(pastedText);
    const hasNegative = this.blockNegative && pastedText.includes('-');

    if (hasNumber || hasNegative) {
      event.preventDefault();
    }
  }

  @HostListener('blur')
  onBlur(): void {
    if (this.resetNegative) {
      const value = parseFloat(this.el.nativeElement.value);
      if (!isNaN(value) && value < 0) {
        this.el.nativeElement.value = '0';
        if (this.control?.control) {
          this.control.control.setValue(0);
        }
      }
    }
  }
}
